export default __webpack_public_path__ + "static/media/fb.77c579a3.svg";